export type AdminTabId =
  | "price-lists"
  | "limits-enrich"
  | "categories"
  | "checks"
  | "requests"
  | "policy-checks"
  | "it-checks"
  | "tariff-requests"
  | "payments"
  | "users";

export interface AdminTabDefinition {
  id: AdminTabId;
  label: string;
}

export const ADMIN_TABS: readonly AdminTabDefinition[] = [
  { id: "price-lists", label: "Тарифы" },
  { id: "limits-enrich", label: "Докупка" },
  { id: "categories", label: "Категории" },
  { id: "checks", label: "Проверки" },
  { id: "requests", label: "Мои сайты" },
  { id: "policy-checks", label: "Проверка политики обработки ПД" },
  { id: "it-checks", label: "Проверка минцифры" },
  { id: "tariff-requests", label: "Запросы" },
  { id: "payments", label: "Платежи" },
  { id: "users", label: "Пользователи" },
] as const;

export const DEFAULT_ADMIN_TAB: AdminTabId = ADMIN_TABS[0].id;

export const isAdminTabId = (value: string | null | undefined): value is AdminTabId =>
  Boolean(value && ADMIN_TABS.some((tab) => tab.id === value));

export const resolveAdminTab = (value: string | null | undefined): AdminTabId =>
  isAdminTabId(value) ? value : DEFAULT_ADMIN_TAB;
